module.exports = window["MaterialUI"].Toolbar;